import { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
 
const ModalView = ({ handleModal, modal, children, url }) => {
    useEffect(() => {
        const parentDiv = document.getElementById('image');
        if (parentDiv) {
            const children = parentDiv?.querySelectorAll('*');
            children?.forEach(child => child.remove());
            const imageEl = document.createElement('img');
            imageEl.src = modal.url;
            imageEl.style.width = '400px';
            imageEl.style.height = '280px';
            imageEl.style.border = 'none';
 
            parentDiv.appendChild(imageEl);
        }
 
        return () => {
            if (parentDiv) {
                const children = parentDiv?.querySelectorAll('*');
                children?.forEach(child => child.remove());
            }
        }
    }, [modal?.url]);
    return <div className="z-[999999] fixed top-0 left-0 w-full flex items-center justify-center bg-black bg-opacity-50 h-screen">
        {/* Modal */}
        <div className="bg-white justify-center items-center px-6 py-2 rounded shadow-lg mt-5 mb-12 flex flex-col relative shadow-md max-w-[90%] md:max-w-[800px] w-full overflow-auto h-[92%]">
            {/* Add Invoice Submission Component */}
            {children}
            {/* Close icon */}
            <div
                className="absolute top-2 right-6 cursor-pointer"
                onClick={() => handleModal(false)}
            >
                <AiOutlineClose className="h-6 w-6 text-gray-500" />
            </div>
        </div>
    </div>
}
 
export default ModalView;